import type { RootState } from '/business/shared/state/store';
/*
 * Gets question definitions as downloaded via fetchInitial
 */

export default (state: RootState) => state.staticProps || { fetched: false };
